import type { AccountRegions } from '@payaca/types/accountTypes';
import { action } from 'typesafe-actions';

import type { LoqateAddressResult } from '@payaca/types/addressTypes';
import { ActionType } from './validationTypes';

export const requestLookupAddressBySearchTerm = (
  searchTerm: string,
  containerId: string,
  region: AccountRegions,
  callback: (error: any, isValid: boolean) => void
) => {
  return action(ActionType.REQUEST_LOOKUP_ADDRESS_BY_SEARCH_TERM, {
    searchTerm,
    containerId,
    region,
    callback,
  });
};
export const lookupAddressBySearchTermSuccess = (
  addressResults: LoqateAddressResult[]
) => {
  return action(ActionType.LOOKUP_ADDRESS_BY_SEARCH_TERM_SUCCESS, {
    addressResults,
  });
};
export const lookupAddressBySearchTermFailure = (error: Error) => {
  return action(
    ActionType.LOOKUP_ADDRESS_BY_SEARCH_TERM_FAILURE,
    null,
    null,
    error
  );
};

export const requestRetrieveAddress = (
  addressId: string,
  callback: (error: any, resp: any) => void
) => {
  return action(ActionType.REQUEST_RETRIEVE_ADDRESS, {
    addressId,
    callback,
  });
};
export const retrieveAddressSuccess = () => {
  return action(ActionType.RETRIEVE_ADDRESS_SUCCESS);
};
export const retrieveAddressFailure = (error: Error) => {
  return action(ActionType.RETRIEVE_ADDRESS_FAILURE, null, null, error);
};
